import React, {Component} from 'react';

import moment from 'moment-timezone'
import { connect } from 'react-redux'

import OpButton from 'common/views/components/OpButton'

import { fetchAdminControlState, updateBogotaLeadsSetting, updateYonyxFallbackSetting } from 'common/redux/support'
import { updateLeadPreferences } from 'common/redux/lead'
import {APP_ENV_PROD} from "common/constants"

const mapDispatchToProps = dispatch => ({
    dispatch
})

class AdminControls extends Component {

  audio = new Audio('http://soundbible.com/mp3/BOMB_SIREN-BOMB_SIREN-247265934.mp3')

  componentDidMount() {
    this.props.handleEnter(this.handleKeyDown)
    this.props.dispatch(fetchAdminControlState())
    if (_.get(this, 'props.auth.user.feature_flags.sound_enabled')) {
      this.audio.play()
    }
  }

  componentWillUnmount() {
    if (_.get(this, 'props.auth.user.feature_flags.sound_enabled')) {
      this.audio.pause()
    }
  }

  handleKeyDown = (e) => {
    if (e.ctrlKey && e.shiftKey) {
      if (e.keyCode === 79) {  // O
        this.props.handleExit()
      } else if (e.keyCode === 76) {  // L
        this.handleAutoFillLead()
      }
    }
  }

  handleUpdateBogotaSetting = _.debounce((target) => {
    this.props.dispatch(updateBogotaLeadsSetting(target))
  }, 800)

  handleUpdateYonyxSetting = _.debounce((target) => {
    this.props.dispatch(updateYonyxFallbackSetting(target))
  }, 800)

  handleAutoFillLead = () => {
    const leadHash = _.get(this, 'props.lead.lead.hash')
    if (leadHash) {
      this.props.dispatch(updateLeadPreferences(leadHash, {
        declined_lender: false,
        likelihood_category: 'asap',
        meet_with_agent_at: null,
        meet_with_lender_at: moment('2022-1-1'),
        price_category: '300-500',
        mortgage_loan_type: 'traditional',
        agent_gender_preference: 'no-preference',
        errors: {},
        market_id: 1007,
        note: 'Autofilled',
        mortgage_employment_category: 'single-employer-paycheck',
        meet_with_agent_date: null,
        buyer_location: 'out-of-town',
        primary_zip: '78741',
        property_category: 'no-preference',
        is_motivated: false,
        existing_agent_status: 'no-agent',
        max_budget_category: 'max-budget',
        listing_property_address: null,
        saveEnabled: true,
        motivation_category: 'first-time-home-buyer',
        agent_language_preference: 'no-preference',
        mortgage_credit_score: 'excellent',
        financing_interest: null,
        availability_time_selection: 'asap',
        client_category: 'buyer',
        max_budget: 500000,
        financing_category: 'already-pre-qualified',
        meet_with_agent_time: null,
        resolution: 'active',
        has_military_connection: true
      }, {}))
    }
    this.props.handleExit()
  }

  render() {

      const { is_bogota_new_leads, is_yonyx_fallback, isLoadingAdminState } = this.props

      return (
        <div className="AdminControls">
          <div className="AdminControls__title">Admin Controls</div>
          <OpButton onClick={() => this.handleUpdateBogotaSetting(!is_bogota_new_leads)} disabled={isLoadingAdminState}>Turn {is_bogota_new_leads ? "OFF" : "ON"} Bogata New Leads</OpButton>
          <OpButton onClick={() => this.handleUpdateYonyxSetting(!is_yonyx_fallback)} disabled={isLoadingAdminState}>Turn {is_yonyx_fallback ? "OFF" : "ON"} Yonyx Fallback</OpButton>
          {window.OD.initialState.env !== APP_ENV_PROD &&
          <OpButton onClick={() => this.handleAutoFillLead()}>Autofill Lead</OpButton>
          }
        </div>
      )
  }
}

export default connect((state) => ({...state.support, lead: state.lead, auth: state.auth}), mapDispatchToProps)(AdminControls)
